import React from 'react';

const webDevPortfolioItems = [
  {
    id: 1,
    image: '/assets/images/web-dev/webdev (1).png',
    title: 'Custom Web Application',
    category: 'Corporate & SaaS',
    platform: 'Custom Web Dev'
  },
  {
    id: 2,
    image: '/assets/images/web-dev/webdev (2).png',
    title: 'E-Commerce Platform',
    category: 'Retail & Storefront',
    platform: 'E-Commerce Solution'
  },
  {
    id: 3,
    image: '/assets/images/web-dev/webdev (3).png',
    title: 'Enterprise Business Portal',
    category: 'Logistics & Mobility',
    platform: 'Full-Stack Web App'
  },
  {
    id: 4,
    image: '/assets/images/web-dev/webdev (4).png',
    title: 'Luxury Brand Showcase',
    category: 'Fashion & Lifestyle',
    platform: 'Responsive Web Design'
  },
  {
    id: 5,
    image: '/assets/images/web-dev/webdev (5).png',
    title: 'Interactive Digital Experience',
    category: 'Media & Marketing',
    platform: 'Front-End Experience'
  },
  {
    id: 6,
    image: '/assets/images/web-dev/webdev (6).png',
    title: 'Global Retail Hub',
    category: 'Marketplace',
    platform: 'High-Converting Web'
  },
  {
    id: 7,
    image: '/assets/images/web-dev/webdev (7).png',
    title: 'Modern CMS & Blog Platform',
    category: 'Publishing & Media',
    platform: 'WordPress Development'
  },
  {
    id: 8,
    image: '/assets/images/web-dev/webdev (8).png',
    title: 'Dynamic Web Platform',
    category: 'Consumer & Business',
    platform: 'Modern Web Architecture'
  }
];

function WebDevelopmentPortfolio() {
  const handleConsultationClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdev-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="ecom-portfolio-section">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-portfolio-header">
          <div className="ecom-portfolio-badge-row">
            <span className="ecom-portfolio-badge">Featured Work & Masterpieces</span>
            <div className="ecom-portfolio-badge-line"></div>
          </div>

          <h2 className="ecom-portfolio-title">
            Website Development <span className="text-red">Portfolio</span>
          </h2>

          <p className="ecom-portfolio-subtitle">
            Explore our curated showcase of bespoke, high-performing websites engineered for modern brands. Hover over any design to explore full page layout from top to bottom.
          </p>
        </div>

        {/* Portfolio 4-Column Grid */}
        <div className="ecom-portfolio-grid">
          {webDevPortfolioItems.map((item) => (
            <div key={item.id} className="ecom-portfolio-card" onClick={handleConsultationClick}>
              {/* Browser Window Frame Header */}
              <div className="ecom-portfolio-window-bar">
                <div className="ecom-window-dots">
                  <span className="ecom-dot dot-red"></span>
                  <span className="ecom-dot dot-yellow"></span>
                  <span className="ecom-dot dot-green"></span>
                </div>
                <span className="ecom-window-title">{item.platform}</span>
              </div>

              {/* Scrollable Image Frame */}
              <div className="ecom-portfolio-img-frame">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="ecom-portfolio-img"
                  loading="lazy"
                />

                {/* Hover Hint Overlay */}
                <div className="ecom-hover-hint">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="7 13 12 18 17 13" />
                    <polyline points="7 6 12 11 17 6" />
                  </svg>
                  <span>Auto-scrolling</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WebDevelopmentPortfolio;
